import cx from 'helpers/cx'

import styles from './Flip.module.css'
import type { FlipAxis, FlipProps } from './Flip.types'

const axisClassName: Record<FlipAxis, string> = {
    x: styles.axisX,
    y: styles.axisY,
    xy: styles.axisXy,
}

/**
 * Flips its children along an axis while `isFlipped` is true.
 * The transform sits on this wrapper, so the child needs no class name.
 */
export const Flip = ({
    axis = 'xy',
    isFlipped = true,
    children,
}: FlipProps) => (
    <span className={cx(styles.flip, isFlipped && axisClassName[axis])}>
        {children}
    </span>
)
